import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
//import { useNavigate, useParams, Link } from 'react-router-dom';

const AppCode = (props) => {

    //let navigate = useNavigate();

    //let {accountKey, appKey} = useParams();
    let appKey = props.appKey ? `'${props.appKey}'` : 'process.env.RECONIFY_APP_KEY';
    let apiKey = props.apiKey ? `'${props.apiKey}'` : 'process.env.RECONIFY_API_KEY';

    let openaiNode = `
import { OpenAI} from "openai";
import { reconifyOpenAIHandler } from 'reconify';

const openai = new OpenAI({
    apiKey: process.env.OPENAI_API_KEY
});

const reconify = reconifyOpenAIHandler(openai, {
    appKey: ${props.appKey ? `'${props.appKey}'` : 'process.env.RECONIFY_APP_KEY'}, 
    apiKey: ${props.apiKey ? `'${props.apiKey}'` : 'process.env.RECONIFY_API_KEY'}
});

reconify.setUser({
    userId: "12345",
    firstName: "Jim",
    lastName: "Stand"
});

const completion = await openai.chat.completions.create({
    model: "gpt-3.5-turbo",
    messages: [
    {role: "system", content: "you are an expert on comedians"},
    {role: "user", content: "tell a joke about cats like Jerry Seinfeld"}
    ]
});
    `;
    let openaiPython = `
from openai import OpenAI
from reconify import reconifyOpenAIHandler

openai_client = OpenAI(api_key = 'YOUR_OPENAI_KEY')

reconifyOpenAIHandler.config(openai_client, ${props.appKey ? `'${props.appKey}'` : "os.environ.get('RECONIFY_APP_KEY')"}, ${props.apiKey ? `'${props.apiKey}'` : "os.environ.get('RECONIFY_API_KEY')"})

reconifyOpenAIHandler.setUser({
   "userId": "12345",
   "firstName": "Jim",
   "lastName": "Stand"
})

response = openai_client.chat.completions.create(
    model="gpt-3.5-turbo",
    messages=[
        {"role": "system", "content": "You are an expert on comedians."},
        {"role": "user", "content": "Tell a joke about cats"},
    ],
    temperature=0,
)
    `;

    let openaiRest = `
{
    "reconify": {
        "format": "openai",
        "type": "completion",
        "version": "1.0.0",
        "appKey": ${props.appKey ? `"${props.appKey}"` : 'process.env.RECONIFY_APP_KEY'},
        "apiKey": ${props.apiKey ? `"${props.apiKey}"` : 'process.env.RECONIFY_API_KEY'}
    },
    "timestamps": {
        "request": 1686091778298,
        "response": 1686091844345
    },
    "user": {
        "userId": "ABC123",
        "firstName": "Jane",
        "lastNam": "Doe"
    },
    "request": {
        "model": "text-davinci-003",
        "prompt": "say this is a test",
        "max_tokens": 7,
        "temperature": 0
    },
    "response": {
        "id": "cmpl-abcdef1234",
        "object": "text_completion",
        "created": 1589478378,
        "model": "text-davinci-003",
        "choices": [{
            "text": "\\n\\nThis is indeed a test",
            "index": 0,
            "logprobs": null,
            "finish_reason": "length"
        }],
        "usage": {
            "prompt_tokens": 5,
            "completion_tokens": 7,
            "total_tokens": 12
        }
    }
}
`

let bedrockNode = `
import { BedrockRuntimeClient, InvokeModelCommand } from "@aws-sdk/client-bedrock-runtime";
import { reconifyBedrockRuntimeHandler } from 'reconify';

const client = new BedrockRuntimeClient({
    region: "us-west-2"
    credentials: {
        accessKeyId: process.env.AWS_ACCESS_KEY,
        secretAccessKey: process.env.AWS_SECRET_KEY
    }
});

const reconify = reconifyBedrockRuntimeHandler({
    appKey: ${props.appKey ? `'${props.appKey}'` : 'process.env.RECONIFY_APP_KEY'}, 
    apiKey: ${props.apiKey ? `'${props.apiKey}'` : 'process.env.RECONIFY_API_KEY'}
});

client.middlewareStack.use(reconify.plugin());

reconify.setUser({
    userId: "12345",
    firstName: "Jane",
    lastName: "Smith"
});

const command = new InvokeModelCommand({
    modelId: "anthropic.claude-instant-v1",
    contentType: "application/json",
    accept: "application/json",
    body: "{\"prompt\":\"\\n\\nHuman: Tell a cat joke.\\n\\nAssistant:\",\"max_tokens_to_sample\":300,\"temperature\":1,\"top_k\":250,\"top_p\":0.999,\"stop_sequences\":[\"\\n\\nHuman:\"],\"anthropic_version\":\"bedrock-2023-05-31\"}"
});

const results = await client.send(command);
    `

let bedrockPython = `
import boto3
from reconify import reconifyBedrockRuntimeHandler

bedrock = boto3.client('bedrock-runtime')

reconifyBedrockRuntimeHandler.config(bedrock, ${props.appKey ? `'${props.appKey}'` : "os.environ.get('RECONIFY_APP_KEY')"}, ${props.apiKey ? `'${props.apiKey}'` : "os.environ.get('RECONIFY_API_KEY')"})

reconifyBedrockRuntimeHandler.setUser({
   "userId": "12345",
   "firstName": "Jim",
   "lastName": "Smith"
})

response = bedrock.invoke_model(
    model="anthropic.claude-instant-v1",
    contentType="application/json",
    accept="application/json",
    body= "{\"prompt\":\"\\n\\nHuman: Tell a cat joke.\\n\\nAssistant:\", \"max_tokens_to_sample\":300, \"temperature\":1, \"top_k\":250, \"top_p\":0.999, \"stop_sequences\":[\"\\n\\nHuman:\"], \"anthropic_version\":\"bedrock-2023-05-31\"}"
)
    `;

    let bedrockRest = `
{
    "reconify": {
        "format": "bedrock",
        "type": "chat",
        "version": "1.0.0",
        "appKey": ${props.appKey ? `"${props.appKey}"` : 'process.env.RECONIFY_APP_KEY'},
        "apiKey": ${props.apiKey ? `"${props.apiKey}"` : 'process.env.RECONIFY_API_KEY'}
    },
    "timestamps": {
        "request": 1696450259007,
        "response": 1696450283264
    },
    "user": {
        "userId": "ABC123",
        "firstName": "Jane",
        "lastNam": "Doe"
    },
    "request": {
        "model": "anthropic.claude-instant-v1",
        "contentType": "application/json",
        "accept": "application/json",
        "body": "{\\"prompt\\":\\"\\n\\nHuman: Create a cat joke in the voice of Jerry Seinfeld.\\n\\nAssistant:\\", \\"max_tokens_to_sample\\":300, \\"temperature\\":1, \\"top_k\\":250, \\"top_p\\":0.999, \\"stop_sequences\\":[\\"\\n\\nHuman:\\"], \\"anthropic_version\\":\\"bedrock-2023-05-31\\"}"
    },
    "response": {
        "requestId": "54425f31-4c82-426e-a69c-efe05c886cd0",
        "body": {
            "completion": " Here is a cat joke in the voice of Jerry Seinfeld:\\n\\nWhat's the deal with cats, huh? They sleep all day and then right when you're trying to relax after a long day, that's when they want to play. It's like 'Hey buddy, I just got home. Think I could have a little me time here? But no, the minute I sit down you bring me your favorite mouse toy. What's up with that?' \\n\\nAnd don't even get me started on the litter box thing. So they use a box filled with sand to do their business, but everything else in the house is fair game? I find litter all over. It's under the couch, behind the TV, in my sneakers. Like they're leaving me a trail of clues for some scavenger hunt. And it's not just a few pieces, it's clumps! Clumps of litter everywhere! \\n\\nYou know, cats are funny creatures. They wake you up at 4am just to be fed, but then during the day it's like 'Hey, buddy, what's your problem? Tryna take a nap here.' Am I right? The whole cat thing, it's just one big puzzle. What's the deal?",
            "stop_reason": "stop_sequence"
         }
    }
}
`

let anthropicNode = `
import Anthropic from '@anthropic-ai/sdk';
import { reconifyAnthropicHandler } from 'reconify';

const anthropic = new Anthropic({
   apiKey: process.env.ANTHROPIC_API_KEY,
});

const reconify = reconifyOpenAIHandler(anthropic, {
   appKey: ${props.appKey ? `'${props.appKey}'` : 'process.env.RECONIFY_APP_KEY'}, 
   apiKey: ${props.apiKey ? `'${props.apiKey}'` : 'process.env.RECONIFY_API_KEY'}
});

reconify.setUser({
   userId: "12345",
   firstName: "Jane",
   lastName: "Smith"
});

const completion = await anthropic.completions.create({
   model: "claude-2",
   max_tokens_to_sample: 300,
   prompt: \`\${Anthropic.HUMAN_PROMPT} Tell me a cat joke\${Anthropic.AI_PROMPT}\`
});
    `;

    let anthropicPython = `
from anthropic import Anthropic, HUMAN_PROMPT, AI_PROMPT
from reconify import reconifyAnthropicHandler

anthropic = Anthropic(api_key = 'YOUR_ANTHROPIC_KEY')

reconifyAnthropicHandler.config(anthropic, ${props.appKey ? `'${props.appKey}'` : "os.environ.get('RECONIFY_APP_KEY')"}, ${props.apiKey ? `'${props.apiKey}'` : "os.environ.get('RECONIFY_API_KEY')"})

reconifyAnthropicHandler.setUser({
    "userId": "12345",
    "firstName": "Jim",
    "lastName": "Smith",
})

response = anthropic.completions.create(
    model="claude-2",
    max_tokens_to_sample=300,
    prompt=f"{HUMAN_PROMPT} Tell me a good cat joke{AI_PROMPT}",
)
    `;

    let anthropicRest = `
{
    "reconify": {
        "format": "anthropic",
        "type": "chat",
        "version": "2.1.0",
        "appKey": ${props.appKey ? `"${props.appKey}"` : 'process.env.RECONIFY_APP_KEY'},
        "apiKey": ${props.apiKey ? `"${props.apiKey}"` : 'process.env.RECONIFY_API_KEY'}
    },
    "timestamps": {
        "request": 1701391185825,
        "response": 1701391187868
    },
    "user": {
        "userId": "ABC123",
        "firstName": "Jane",
        "lastNam": "Doe"
    },
    "request": {
        "model": "claude-2",
        "max_tokens_to_sample": 300,
        "prompt": "\\n\\nHuman: Tell me a cat joke\\n\\nAssistant:"
    },
    "response": {
        "completion": " Here's a silly cat joke:\\n\\nWhy don't cats play poker in the jungle? Too many cheetahs!",
        "stop_reason": "stop_sequence",
        "model": "claude-2.1",
        "stop": "\\n\\nHuman:",
        "log_id": "1106334994b78ba877c8f4ce0442910640381ae54b819019e134ce717867d339"
    }
}
`

let cohereNode = `
import { CohereClient } from "cohere-ai";
import { reconifyCohereHandler } from 'reconify';

const cohere = new CohereClient({
   token: process.env.COHERE_API_KEY,
});

const reconify = reconifyCohereHandler(cohere, {
   appKey: ${props.appKey ? `'${props.appKey}'` : 'process.env.RECONIFY_APP_KEY'}, 
   apiKey: ${props.apiKey ? `'${props.apiKey}'` : 'process.env.RECONIFY_API_KEY'}
});

reconify.setUser({
   userId: "12345",
   firstName: "Jane",
   lastName: "Smith"
});

const completion = await cohere.chat({
   model: "command",
   message: "Tell me a cat joke"
});
    `;

    let coherePython = `
from cohere import Client
from reconify import reconifyCohereHandler

cohere_client = Client('YOUR_COHERE_KEY')

reconifyCohereHandler.config(cohere_client, ${props.appKey ? `'${props.appKey}'` : "os.environ.get('RECONIFY_APP_KEY')"}, ${props.apiKey ? `'${props.apiKey}'` : "os.environ.get('RECONIFY_API_KEY')"})

reconifyCohereHandler.setUser({
    "userId": "12345",
    "firstName": "Jim",
    "lastName": "Smith"
})

response = cohere_client.chat(
    model="command",
    message="tell me a good cat joke"
)
    `;

    let cohereRest = `
{
    "reconify": {
        "format": "cohere",
        "type": "chat",
        "version": "2.1.0",
        "appKey": ${props.appKey ? `"${props.appKey}"` : 'process.env.RECONIFY_APP_KEY'},
        "apiKey": ${props.apiKey ? `"${props.apiKey}"` : 'process.env.RECONIFY_API_KEY'}
    },
    "timestamps": {
        "request": 1701460517528,
        "response": 1701460522216
    },
    "user": {
        "userId": "ABC123",
        "firstName": "Jane",
        "lastNam": "Doe"
    },
    "request": {
        "model": "command",
        "message": "Tell me one good cat joke"
    },
    "response": {
        "response_id": "d479aeb3-a87d-41ef-b13f-7a712094106e",
        "text": "Why did the cat cross the road?\\nTo get to the meow-niverse!\\n\\nPurr-fect joke, hahaha? \\n\\nWould you like to hear another one? \\n\\nIf you're feeling adventurous, you could even tell me a joke about cats!",
        "generationId": "6e0f59a0-4469-412e-9279-d552f2b51db4",
        "token_count": {
            "prompt_tokens": 68,
            "response_tokens": 59,
            "total_tokens": 127,
            "billed_tokens": 116
        },
        "meta": {
            "api_version": {
                "version": "1"
            },
            "billed_units": {
                "input_tokens": 57,
                "output_tokens": 59
            }
        }
    }
}
`
let geminiNode = `
import { GoogleGenerativeAI } from '@google/generative-ai';
import { reconifyGeminiHandler } from 'reconify';

const genAI = new GoogleGenerativeAI(process.env.GEMINI_API_KEY);

const reconify = reconifyGeminiHandler(genAI, {
   appKey: ${props.appKey ? `'${props.appKey}'` : 'process.env.RECONIFY_APP_KEY'}, 
   apiKey: ${props.apiKey ? `'${props.apiKey}'` : 'process.env.RECONIFY_API_KEY'}
});

reconify.setUser({
   userId: "12345",
   firstName: "Jane",
   lastName: "Smith"
});

const model = genAI.getGenerativeModel({ model: "gemini-pro" });
const result = await model.generateContent("Tell me a cat joke");
const response = await result.response;
const text = response.text();
    `;

    let geminiPython = `
from cohere import Client
from reconify import reconifyCohereHandler

cohere_client = Client('YOUR_COHERE_KEY')

reconifyCohereHandler.config(cohere_client, ${props.appKey ? `'${props.appKey}'` : "os.environ.get('RECONIFY_APP_KEY')"}, ${props.apiKey ? `'${props.apiKey}'` : "os.environ.get('RECONIFY_API_KEY')"})

reconifyCohereHandler.setUser({
    "userId": "12345",
    "firstName": "Jim",
    "lastName": "Smith"
})

response = cohere_client.chat(
    model="command",
    message="tell me a good cat joke"
)
    `;

    let geminiRest = `
{
    "reconify": {
        "format": "gemini",
        "type": "generate",
        "version": "2.3.0",
        "appKey": ${props.appKey ? `"${props.appKey}"` : 'process.env.RECONIFY_APP_KEY'},
        "apiKey": ${props.apiKey ? `"${props.apiKey}"` : 'process.env.RECONIFY_API_KEY'}
    },
    "timestamps": {
        "request": 1703135407816,
        "response": 1703135409193
    },
    "user": {
        "userId": "ABC123",
        "firstName": "Jane",
        "lastNam": "Doe"
    },
    "request": {
        "contents": [
            {
                "parts": [
                    {
                        "text": "Tell a cat joke"
                    }
                ]
            }
        ],
        "model": "gemini-pro",
        "generationConfig": {
            "maxOutputTokens": 350
        },
        "safetySettings": []
    },
    "response": {
        "candidates": [
            {
                "content": {
                    "parts": [
                        {
                            "text": "Why did the cat join the Red Cross?\nBecause he wanted to be a first-aid kitty!"
                        }
                    ],
                    "role": "model"
                },
                "finishReason": "STOP",
                "index": 0,
                "safetyRatings": [
                    {
                        "category": "HARM_CATEGORY_SEXUALLY_EXPLICIT",
                        "probability": "NEGLIGIBLE"
                    },
                    {
                        "category": "HARM_CATEGORY_HATE_SPEECH",
                        "probability": "NEGLIGIBLE"
                    },
                    {
                        "category": "HARM_CATEGORY_HARASSMENT",
                        "probability": "NEGLIGIBLE"
                    },
                    {
                        "category": "HARM_CATEGORY_DANGEROUS_CONTENT",
                        "probability": "NEGLIGIBLE"
                    }
                ]
            }
        ],
        "promptFeedback": {
            "safetyRatings": [
                {
                    "category": "HARM_CATEGORY_SEXUALLY_EXPLICIT",
                    "probability": "NEGLIGIBLE"
                },
                {
                    "category": "HARM_CATEGORY_HATE_SPEECH",
                    "probability": "NEGLIGIBLE"
                },
                {
                    "category": "HARM_CATEGORY_HARASSMENT",
                    "probability": "NEGLIGIBLE"
                },
                {
                    "category": "HARM_CATEGORY_DANGEROUS_CONTENT",
                    "probability": "NEGLIGIBLE"
                }
            ]
        }
    },
}
`

let mistralNode = `
import { MistralClient} from "@mistralai/mistralai";
import { reconifyMistralHandler } from 'reconify';

const mistral_client = new MistralClient({
    apiKey: process.env.MISTRAL_API_KEY
});

const reconify = reconifyMistralHandler(mistral_client, {
    appKey: ${props.appKey ? `'${props.appKey}'` : 'process.env.RECONIFY_APP_KEY'}, 
    apiKey: ${props.apiKey ? `'${props.apiKey}'` : 'process.env.RECONIFY_API_KEY'}
});

reconify.setUser({
    userId: "12345",
    firstName: "Jim",
    lastName: "Stand"
});

const response = await mistral_client.chat({
    model: "mistral-tiny",
    messages: [
    {role: "system", content: "you are an expert on comedians"},
    {role: "user", content: "tell a joke about cats like Jerry Seinfeld"}
    ]
});
    `;

    let mistralPython = `
from mistralai.client import MistralClient
from reconify import reconifyMistralHandler

mistral_client = MistralClient(api_key = 'YOUR_MISTRAL_KEY')

reconifyMistralHandler.config(mistral_client, ${props.appKey ? `'${props.appKey}'` : "os.environ.get('RECONIFY_APP_KEY')"}, ${props.apiKey ? `'${props.apiKey}'` : "os.environ.get('RECONIFY_API_KEY')"})

reconifyMistralHandler.setUser({
   "userId": "12345",
   "firstName": "Jim",
   "lastName": "Stand"
})

response = mistral_client.chat(
    model="mistral-tiny",
    messages=[
        {"role": "system", "content": "You are an expert on comedians."},
        {"role": "user", "content": "Tell a joke about cats"},
    ],
    temperature=0,
)
    `;

    let mistralRest = `
{
    "reconify": {
        "format": "mistral",
        "type": "chat",
        "version": "1.0.0",
        "appKey": ${props.appKey ? `"${props.appKey}"` : 'process.env.RECONIFY_APP_KEY'},
        "apiKey": ${props.apiKey ? `"${props.apiKey}"` : 'process.env.RECONIFY_API_KEY'}
    },
    "timestamps": {
        "request": 1704748161152,
        "response": 1704758196343
    },
    "user": {
        "userId": "ABC123",
        "firstName": "Jane",
        "lastNam": "Doe"
    },
    "request": {
        "model": "mistral-tiny",
        "messages": [
            {"role": "user", "content": "Tell me a cat joke"}
        ]
    },
    "response": {
        "id": "cmpl-abcdef1234",
        "object": "chat.completion",
        "created": 1704748168,
        "model": "mistral-tiny",
        "choices": [{
            "index": 0,
            "message": {
                "role" : "assistant",
                "content" : "Why did the cat sit on the ventilation duct?\\n\\nTo become a cat-alogue!'' (This one is for the cat lovers who also appreciate a good pun!)"
            },
            "finish_reason": "stop"
        }],
        "usage": {
            "prompt_tokens": 13,
            "completion_tokens": 38,
            "total_tokens": 51
        }
    }
}
`

let perplexityNode = `
import { api } from 'api';
import { reconifyUniversalHandler } from 'reconify';

const sdk = api('@pplx/v0#b2wdhb1klq5dn1d6')
sdk.auth(process.env.PERPLEXITY_API_KEY);

const reconify = reconifyUniversalHandler({
    appKey: ${props.appKey ? `'${props.appKey}'` : 'process.env.RECONIFY_APP_KEY'}, 
    apiKey: ${props.apiKey ? `'${props.apiKey}'` : 'process.env.RECONIFY_API_KEY'}
});

reconify.setUser({
    userId: "12345",
    firstName: "Jim",
    lastName: "Stand"
});

const start = reconify.getTimestamp();
const input = {
   model: 'pplx-7b-chat',
   messages: [
      { role: "system", content: "You are a comic"},
      { role: 'user', content: 'Tell me a cat joke.'}
   ]
}
const response = await sdk.post_chat_completions(input);
const end = reconify.getTimestamp();

reconify.logChat(input, response.data, start, end);
    `;

    let perplexityPython = `
import requests
from reconify import reconifyUniversalHandler

reconifyUniversalHandler.config(${props.appKey ? `'${props.appKey}'` : "os.environ.get('RECONIFY_APP_KEY')"}, ${props.apiKey ? `'${props.apiKey}'` : "os.environ.get('RECONIFY_API_KEY')"})

reconifyUniversalHandler.setUser({
   "userId": "12345",
   "firstName": "Jim",
   "lastName": "Stand"
})

input = {
    "model":"pplx-7b-chat",
    "messages":[
        {"role": "system", "content": "You are a comic"},
        {"role": "user", "content": "Tell a cat joke"},
    ]
}

start = reconifyUniversalHandler.getTimestamp()

response = requests.post("https://api.perplexity.ai/chat/completions", json=input, headers = {
    "accept":"application/json",
    "content-type":"application/json",
    "authorization": "Bearer YOUR_PERPLEXITY_KEY"
})

end = reconifyUniversalHandler.getTimestamp()

reconifyUniversalHandler.logChat(input, response.text, start, end)
    `;

    let perplexityRest = `
{
    "reconify": {
        "format": "universal",
        "type": "chat",
        "version": "1.0.0",
        "appKey": ${props.appKey ? `"${props.appKey}"` : 'process.env.RECONIFY_APP_KEY'},
        "apiKey": ${props.apiKey ? `"${props.apiKey}"` : 'process.env.RECONIFY_API_KEY'}
    },
    "timestamps": {
        "request": 1707799435307,
        "response": 1707799436158
    },
    "user": {
        "userId": "ABC123",
        "firstName": "Jane",
        "lastNam": "Doe"
    },
    "request": {
        "model": "pplx-7b-chat",
        messages: [
            {"role": "system", "content": "you are a stand up comic"},
            {"role": "user", "content": "Tell me a cat joke"}
        ]
    },
    "response": {
        "id": "cmpl-abcdef1234",
        "object": "chat.completion",
        "created": 1707799436158,
        "model": "pplx-7b-chat",
        "choices": [{
            "index": 0,
            "message": {
                "role" : "assistant",
                "content" : "Here's a lighthearted feline joke for you:\\n\\nWhy don't cats play poker in the jungle?\\n\\nBecause there's too many cheetahs! *(You might have to adjust this joke slightly depending on regional accents and familiarity with specific slang!)*"
            },
            "finish_reason": "stop"
        }],
        "usage": {
            "prompt_tokens": 22,
            "completion_tokens": 63,
            "total_tokens": 85
        }
    }
}
`
    return (
        <div className='mt-5'>
            <h4>Tracking integration</h4>
            <p>
                Below are example integrations. For more details and additional integration options,
                please view the <a href="https://www.reconify.com/docs" target="_blank" rel="noreferrer">documentation</a>.
            </p>
            <Tabs defaultActiveKey={'openai'} >
                <Tab eventKey={'bedrock'} title={'Amazon Bedrock'}>
                    <div className='mt-3'>
                        <p>Select the type of integration to use with Amazon Bedrock:</p>
                    </div>

                    <Tabs defaultActiveKey={'bedrock-node'} className='mt-4' variant='pills'>
                        <Tab eventKey={'bedrock-node'} title={'node'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/bedrock/node" target="_blank" rel="noreferrer">node documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{bedrockNode}</pre></code></div>
                            </div>
                        </Tab>
                        <Tab eventKey={'bedrock-python'} title={'python'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/bedrock/python" target="_blank" rel="noreferrer">python documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{bedrockPython}</pre></code></div>
                            </div>
                        </Tab>
                        <Tab eventKey={'bedrock-rest'} title={'rest'}>
                            <div>
                                <div className='mt-3'>
                                    <p>Below is an example JSON to post to the end point (https://track.reconify.com/track).</p>
                                    <p>View the <a href="https://www.reconify.com/docs/bedrock/restapi" target="_blank" rel="noreferrer">rest documentation</a> for complete details on the JSON format.</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{bedrockRest}</pre></code></div>
                            </div>
                        </Tab>
                    </Tabs>
                </Tab>
                <Tab eventKey={'anthropic'} title={'Anthropic'}>
                    <div className='mt-3'>
                        <p>Select the type of integration to use with Anthropic:</p>
                    </div>

                    <Tabs defaultActiveKey={'anthropic-node'} className='mt-4' variant='pills'>
                        <Tab eventKey={'anthropic-node'} title={'node'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/anthropic/node" target="_blank" rel="noreferrer">node documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{anthropicNode}</pre></code></div>
                            </div>
                        </Tab>
                        <Tab eventKey={'anthropic-python'} title={'python'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/anthropic/python" target="_blank" rel="noreferrer">python documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{anthropicPython}</pre></code></div>
                            </div>
                        </Tab>
                        <Tab eventKey={'anthropic-rest'} title={'rest'}>
                            <div>
                                <div className='mt-3'>
                                    <p>Below is an example JSON to post to the end point (https://track.reconify.com/track).</p>
                                    <p>View the <a href="https://www.reconify.com/docs/anthropic/restapi" target="_blank" rel="noreferrer">rest documentation</a> for complete details on the JSON format.</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{anthropicRest}</pre></code></div>
                            </div>
                        </Tab>
                    </Tabs>
                </Tab>
                <Tab eventKey={'cohere'} title={'Cohere'}>
                    <div className='mt-3'>
                        <p>Select the type of integration to use with Cohere:</p>
                    </div>

                    <Tabs defaultActiveKey={'cohere-node'} className='mt-4' variant='pills'>
                        <Tab eventKey={'cohere-node'} title={'node'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/cohere/node" target="_blank" rel="noreferrer">node documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{cohereNode}</pre></code></div>
                            </div>
                        </Tab>
                        <Tab eventKey={'cohere-python'} title={'python'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/cohere/python" target="_blank" rel="noreferrer">python documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{coherePython}</pre></code></div>
                            </div>
                        </Tab>
                        <Tab eventKey={'cohere-rest'} title={'rest'}>
                            <div>
                                <div className='mt-3'>
                                    <p>Below is an example JSON to post to the end point (https://track.reconify.com/track).</p>
                                    <p>View the <a href="https://www.reconify.com/docs/cohere/restapi" target="_blank" rel="noreferrer">rest documentation</a> for complete details on the JSON format.</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{cohereRest}</pre></code></div>
                            </div>
                        </Tab>
                    </Tabs>
                </Tab>
                <Tab eventKey={'gemini'} title={'Gemini'}>
                    <div className='mt-3'>
                        <p>Select the type of integration to use with Google Gemini:</p>
                    </div>

                    <Tabs defaultActiveKey={'gemini-node'} className='mt-4' variant='pills'>
                        <Tab eventKey={'gemini-node'} title={'node'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/gemini/node" target="_blank" rel="noreferrer">node documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{geminiNode}</pre></code></div>
                            </div>
                        </Tab>
                        {/* 
                        <Tab eventKey={'gemini-python'} title={'python'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/gemini/python" target="_blank" rel="noreferrer">python documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{geminiPython}</pre></code></div>
                            </div>
                        </Tab>
                        */}
                        <Tab eventKey={'gemini-rest'} title={'rest'}>
                            <div>
                                <div className='mt-3'>
                                    <p>Below is an example JSON to post to the end point (https://track.reconify.com/track).</p>
                                    <p>View the <a href="https://www.reconify.com/docs/gemini/restapi" target="_blank" rel="noreferrer">rest documentation</a> for complete details on the JSON format.</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{geminiRest}</pre></code></div>
                            </div>
                        </Tab>
                    </Tabs>
                </Tab>
                <Tab eventKey={'mistral'} title={'Mistral'}>
                    <div className='mt-3'>
                        <p>Select the type of integration to use with Mistral:</p>
                    </div>

                    <Tabs defaultActiveKey={'mistral-node'} className='mt-4' variant='pills'>

                        <Tab eventKey={'mistral-node'} title={'node'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/mistral/node" target="_blank" rel="noreferrer">node documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{mistralNode}</pre></code></div>
                            </div>
                        </Tab>
                        <Tab eventKey={'mistral-python'} title={'python'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/mistral/python" target="_blank" rel="noreferrer">python documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{mistralPython}</pre></code></div>
                            </div>
                        </Tab>
                        <Tab eventKey={'mistral-rest'} title={'rest'}>
                            <div>
                                <div className='mt-3'>
                                    <p>Below is an example JSON to post to the end point (https://track.reconify.com/track).</p>
                                    <p>View the <a href="https://www.reconify.com/docs/mistral/restapi" target="_blank" rel="noreferrer">rest documentation</a> for complete details on the JSON format.</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{mistralRest}</pre></code></div>
                            </div>
                        </Tab>
                    </Tabs>
                </Tab>
                <Tab eventKey={'openai'} title={'OpenAI'}>
                    <div className='mt-3'>
                        <p>Select the type of integration to use with OpenAI:</p>
                    </div>

                    <Tabs defaultActiveKey={'openai-node'} className='mt-4' variant='pills'>

                        <Tab eventKey={'openai-node'} title={'node'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/openai/node" target="_blank" rel="noreferrer">node documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{openaiNode}</pre></code></div>
                            </div>
                        </Tab>
                        <Tab eventKey={'openai-python'} title={'python'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/openai/python" target="_blank" rel="noreferrer">python documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{openaiPython}</pre></code></div>
                            </div>
                        </Tab>
                        <Tab eventKey={'openai-rest'} title={'rest'}>
                            <div>
                                <div className='mt-3'>
                                    <p>Below is an example JSON to post to the end point (https://track.reconify.com/track).</p>
                                    <p>View the <a href="https://www.reconify.com/docs/openai/restapi" target="_blank" rel="noreferrer">rest documentation</a> for complete details on the JSON format.</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{openaiRest}</pre></code></div>
                            </div>
                        </Tab>
                    </Tabs>
                </Tab>
                <Tab eventKey={'perplexity'} title={'Perplexity'}>
                    <div className='mt-3'>
                        <p>Select the type of integration to use with Perplexity:</p>
                    </div>

                    <Tabs defaultActiveKey={'perplexity-node'} className='mt-4' variant='pills'>

                        <Tab eventKey={'perplexity-node'} title={'node'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/perplexity/node" target="_blank" rel="noreferrer">node documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{perplexityNode}</pre></code></div>
                            </div>
                        </Tab>
                        <Tab eventKey={'perplexity-python'} title={'python'}>
                            <div>
                                <div className='mt-3'>
                                    <p>View <a href="https://www.reconify.com/docs/perplexity/python" target="_blank" rel="noreferrer">python documentation</a> for additional options and examples</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{perplexityPython}</pre></code></div>
                            </div>
                        </Tab>
                        <Tab eventKey={'perplexity-rest'} title={'rest'}>
                            <div>
                                <div className='mt-3'>
                                    <p>Below is an example JSON to post to the end point (https://track.reconify.com/track).</p>
                                    <p>View the <a href="https://www.reconify.com/docs/perplexity/restapi" target="_blank" rel="noreferrer">rest documentation</a> for complete details on the JSON format.</p>
                                </div>
                                <div className='code-block my-2 px-4 py-2'><code className='code'><pre>{perplexityRest}</pre></code></div>
                            </div>
                        </Tab>
                    </Tabs>
                </Tab>
            </Tabs>

        </div>
    )

}

export default AppCode;
